<current-slip-core (closeInformerModal)="closeBottomSheet($event)"></current-slip-core>
